// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"101":"a9baa3c4","174":"e9398b6a","232":"e2719ef1","334":"556ab64f","381":"9733c5aa","606":"7b788738","941":"c7b581f0"}[chunkId] + ".chunk.js";
};